exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".xue-modal-mask {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #314659;\n  z-index: 99; }\n\n.xue-modal-content {\n  position: fixed;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  background-color: #fff;\n  z-index: 100;\n  min-width: 200px;\n  border-radius: 4px; }\n  .xue-modal-content > .xue-modal-header {\n    padding: 20px 16px;\n    color: rgba(0, 0, 0, 0.85);\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 500;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n  .xue-modal-content > .xue-modal-body {\n    padding: 0 24px;\n    color: rgba(0, 0, 0, 0.65);\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: 400; }\n  .xue-modal-content > .xue-modal-footer {\n    padding: 10px 16px;\n    text-align: end;\n    color: rgba(0, 0, 0, 0.65);\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: 400;\n    border-top: 1px solid rgba(0, 0, 0, 0.15); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/packages/modal/style/index.scss
// module id = 155
// module chunks = 0